export const HttpStatusCode = {
  Ok: 200,
  Created: 201,
  BadRequest: 400,
  Unauthorized: 401,
  Forbidden: 403,
  NotFound: 404,
  InternalServerError: 500,
  GatewayTimeout: 504,
};

export const HttpStatusCodeResponse = {
  InternalServerError: {
    responseCode: HttpStatusCode.InternalServerError,
    responseMessage: 'Internal Server Error. Please try again later.',
  },
};
